import React, {
  useEffect,
} from "react";

import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import "./css/SuccessScreen.css";


function SuccessScreen() {

  const navigate = useNavigate();

  const location = useLocation();


  const {
    restaurantId,
    tableId,
  } = useParams();


  // =====================================================
  // SUCCESS DATA
  // =====================================================

  const {
    orderId,
    orderNumber,
    paymentMethod,
    total,
    paymentId,
  } = location.state || {};


  // =====================================================
  // HOME PATH
  // =====================================================

  const homePath =
    `/${restaurantId}/table/${tableId}`;


  // =====================================================
  // AUTO REDIRECT
  // =====================================================

  useEffect(() => {

    const timer =
      setTimeout(() => {

        navigate(
          homePath,
          {
            replace: true,
          }
        );

      }, 10000);


    return () => {

      clearTimeout(timer);

    };

  }, [
    navigate,
    homePath,
  ]);


  // =====================================================
  // FORMAT PRICE
  // =====================================================

  const formattedTotal =
    Number(
      total || 0
    ).toFixed(2);


  // =====================================================
  // PAYMENT LABEL
  // =====================================================

  const paymentLabel =
    paymentMethod === "ONLINE"
      ? "Online Payment"
      : "Pay at Table";


  // =====================================================
  // RENDER
  // =====================================================

  return (

    <main className="theme8-success-page">


      {/* =================================================
          SUCCESS MAIN
      ================================================= */}

      <section className="theme8-success-main">

        <div className="theme8-success-card">


          {/* =================================================
              DECORATIVE YELLOW ELEMENT
          ================================================= */}

          <div className="theme8-success-accent">
          </div>


          {/* =================================================
              CHECK ICON
          ================================================= */}

          <div className="theme8-success-icon">

            <span>
              ✓
            </span>

          </div>


          {/* =================================================
              LABEL
          ================================================= */}

          <span className="theme8-success-label">
            ORDER CONFIRMED
          </span>


          {/* =================================================
              TITLE
          ================================================= */}

          <h1>
            Thank You
          </h1>


          {/* =================================================
              MESSAGE
          ================================================= */}

          <p className="theme8-success-message">

            Your order has been received
            and is being prepared fresh
            for your table.

          </p>


          {/* =================================================
              ORDER NUMBER
          ================================================= */}

          <div className="theme8-success-order">

            <span>
              ORDER
            </span>

            <strong>
              {orderNumber ||
                `#${orderId || "—"}`}
            </strong>

          </div>


          {/* =================================================
              ORDER DETAILS
          ================================================= */}

          <div className="theme8-success-details">


            {/* TABLE */}

            <div className="theme8-success-detail">

              <span>
                TABLE
              </span>

              <strong>
                {tableId}
              </strong>

            </div>


            {/* PAYMENT */}

            <div className="theme8-success-detail">

              <span>
                PAYMENT
              </span>

              <strong>
                {paymentLabel}
              </strong>

            </div>


            {/* TOTAL */}

            <div className="theme8-success-detail">

              <span>
                TOTAL
              </span>

              <strong>
                ₹
                {formattedTotal}
              </strong>

            </div>

          </div>


          {/* =================================================
              ONLINE PAYMENT ID
          ================================================= */}

          {paymentMethod === "ONLINE" &&
            paymentId && (

              <div className="theme8-payment-id">

                <span>
                  PAYMENT ID
                </span>

                <strong>
                  {paymentId}
                </strong>

              </div>

            )}


          {/* =================================================
              CASH MESSAGE
          ================================================= */}

          {paymentMethod === "CASH" && (

            <div className="theme8-cash-message">

              <div className="theme8-cash-icon">
                ₹
              </div>

              <p>

                Please keep your payment ready.
                You can pay at the table when
                your order is served.

              </p>

            </div>

          )}


          {/* =================================================
              BACK TO MENU
          ================================================= */}

          <button
            type="button"
            className="theme8-success-home-button"
            onClick={() =>
              navigate(
                homePath,
                {
                  replace: true,
                }
              )
            }
          >

            Back to Menu

            <span>
              →
            </span>

          </button>


          {/* =================================================
              REDIRECT MESSAGE
          ================================================= */}

          <p className="theme8-success-redirect">

            You will be returned to the menu
            automatically in a few seconds.

          </p>

        </div>

      </section>



      {/* =================================================
          BRAND FOOTER
      ================================================= */}

      <footer className="theme8-success-footer">

        <div className="theme8-success-footer-brand">

          <span>
            SAFFRON EMBER
          </span>

          <small>
            INDIAN CUISINE
          </small>

        </div>


        <p>
          Authentic flavours · Fresh ingredients ·
          Memorable experiences
        </p>

      </footer>

    </main>

  );

}


export default SuccessScreen;